import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouse4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "house-4" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "1.5 9.744 12 0.744 22.5 9.744"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,5.244,3.377,12.61a1.186,1.186,0,0,0-.377.8v8.855a.981.981,0,0,0,.978.978H9.75v-7.01a.491.491,0,0,1,.489-.49h3.522a.491.491,0,0,1,.489.49v7.01h5.772A.981.981,0,0,0,21,22.266V13.411a1.186,1.186,0,0,0-.377-.8Z"
		})
	]
});
export default SvgHouse4;
